// 点位图间隙宽度比例 0.5为2:1, 2为有色图 1为留白间隙
export const GAP_RATIO = 0.5;
// 输出比例 如果2 则按两倍画布绘制 最后scale为0.5 【提高清晰度】
export const DRAW_RATIO = 2;
// 绘制位图形状
export const SHAP_ENUM = {
  RECT: 'RECT',
  CIRCLE: 'CIRCLE'
};